import Glide from '@glidejs/glide';

export default function GlideAutoCarousel(carouselId) {

    let carouselWrapper = document.querySelector(carouselId);
    let carouselDir = document.dir?.length > 0 ? document.dir : 'ltr';
    if(carouselWrapper) {
        const carousel = new Glide(carouselId, {
            type: 'carousel',
            autoplay: 5000,
            animationDuration: 800,
            startAt: 0,
            gap: 15,
            perView: 3,
            direction: carouselDir,
            breakpoints: {
                991: { 
                    perView: 1,
                    peek: {
                        before: 30,
                        after: 30
                    },
                }
            }
        })
        carousel.mount();
    }
}